<template>
  <div class="headerS">
    <el-header id="header">
      <div>
        <span class="hideAside" @click="collapse">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
        <span class="title">
          {{ $store.state.eduWebConfig.hospitalWebConfigInfo.webName }}</span
        >
      </div>

      <ul class="personal">
        <li class="fullScreen" @click="fullScreen"></li>
        <li>
          <!-- {{ HospitalName }} -->
          {{ this.$store.getters.info.HospitalName }}
          <!-- <langSelect></langSelect> -->
        </li>
        <li>
          {{
            $store.getters.isCompany
              ? "心理咨询师"
              : this.$store.getters.info.RoleName
          }}
        </li>
        <li v-if="roleid == 4 || roleid == 3" class="headerIcon alarm_warp">
          <el-popover
            placement="bottom"
            title
            width="880"
            v-model="isShow"
            trigger="click"
          >
            <div class="message_popover">
              <div class="head">
                <div class="message_head">
                  <div class="title">告警信息</div>
                  <div class="more">
                    <el-tooltip
                      class="item details"
                      effect="dark"
                      content="更多"
                      placement="bottom"
                    >
                      <i class="el-icon-more" @click="toAlarmPage"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="line"></div>
                <div class="message_head_warp">
                  <div class="all_warp">
                    <span class="total_all" style="padding-right: 8px"
                      >全部</span
                    >
                    <span class="total_text">{{ alarmObj.AlarmNum }}</span>
                  </div>
                  <li class="total_line">|</li>
                  <div class="circular_warp" style="margin: 0 30px">
                    <span class="circular"></span>
                    <span class="people">告警人数：</span>
                    <span class="text text_num" style="color: #d43c3c">{{
                      alarmObj.AlarmPersonNum
                    }}</span>
                  </div>
                  <div class="circular_warp">
                    <span class="circular" style="background: #ff9824"></span>
                    <span class="people">告警量表数：</span>
                    <span class="text text_num" style="color: #ff9824">{{
                      alarmObj.AlarmScaleNum
                    }}</span>
                  </div>
                </div>
              </div>
              <table class="alarm_tab">
                <tr>
                  <th width="160px">告警程度</th>
                  <th width="100px">告警人员</th>
                  <th width="340px">告警量表</th>
                  <th width="260px" style="text-align: center">操作</th>
                </tr>
                <tr v-for="(item, index) in alarmObj.Data" :key="index">
                  <td>
                    <span
                      v-if="item.DegreeName != ''"
                      class="alarm_severity"
                      :style="{
                        background: item.DegreeColor,
                      }"
                      >{{ item.DegreeName }}</span
                    >
                  </td>
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Title }}</td>
                  <td class="operation" style="text-align: center">
                    <span @click="handleDetailReport(item)">查看报告</span>
                    <span @click="handleAnswerRecord(item)">答题情况</span>
                    <span @click="ignoreAlarm(item)">忽略</span>
                    <!-- <span @click="solveAlarm(item, index)">解决</span> -->
                    <span @click="solveAlarm(item)">解决</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="message_warp" slot="reference">
              <span
                class="message_number"
                v-show="isMessageShow && alarmObj.AlarmNum"
                >{{ alarmObj.AlarmNum }}</span
              >
              <i
                class="fa fa-bell-o"
                aria-hidden="true"
                style="font-size: 22px; color: #fff"
              ></i>
            </div>
          </el-popover>
        </li>
        <li class="headerIcon" style="margin-right: 0">
          <i
            class="fa fa-user-o"
            aria-hidden="true"
            style="font-size: 22px; color: #fff"
          ></i>
        </li>
        <li>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: white">
              {{ user }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePassword">{{
                $t("userDropdownMenu.changePassword")
              }}</el-dropdown-item>
              <el-dropdown-item command="logout" divided>{{
                $t("userDropdownMenu.logout")
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </el-header>
    <!-- 查看心里训练二维码弹框 -->
    <el-dialog
      title="查看二维码"
      :visible.sync="trainQrCodeVisible"
      width="800px"
      :append-to-body="true"
      @opened="trainOpenQrDialog"
      @close="closeQrCodeDialog"
    >
      <div id="trainQrCode" class="traincontent">
        <!-- 打印报告头 -->
        <div class="title_warp">
          <div class="date">{{ nowDate }}</div>
          <div class="hospital">
            {{ this.$store.getters.info.HospitalName }}
          </div>
        </div>
        <!--  -->
        <div class="title">心理健康训练</div>
        <div class="print-Warp">
          <!-- 个人基本信息展示 -->
          <table class="tab" v-if="parintinfo">
            <tr>
              <td class="td_left td_top topOne">编号：{{ trainID }}</td>
              <td class="td_top">姓名：{{ parintinfo.RegisterName }}</td>
              <td class="td_right td_top">性别：{{ parintinfo.GenderName }}</td>
            </tr>
            <tr>
              <td class="td_left">年龄：{{ parintinfo.Age }}</td>
              <td>医院名称：{{ this.$store.getters.info.HospitalName }}</td>
              <td class="td_right">科室：{{ parintinfo.DepartmentName }}</td>
            </tr>
            <tr>
              <td class="td_left">医生：{{ parintinfo.DoctorName }}</td>
              <td colspan="2">诊断描述：</td>
            </tr>
          </table>
          <!-- 训练信息 -->
          <div class="subTitle train-bottom">训练信息</div>
          <table class="tab">
            <thead>
              <tr>
                <td style="width: 300px">训练方式</td>
                <td>描述</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in checkedTrainNames" :key="index">
                <td>{{ item.Name }}</td>
                <td class="td_right">{{ item.Describe }}</td>
              </tr>
            </tbody>
          </table>
          <!-- 二维码 -->
          <div class="subTitle border-bottom">二维码</div>
          <div class="canvas-bar">
            <div class="box">
              <div class="canvas-warp">
                <canvas width="180px" height="180px" id="trainCanvas"></canvas>
              </div>
            </div>
          </div>
          <!-- 医生签字 -->
        </div>
        <div class="text-right" style="display: none">
          <div>
            医生签字：
            <span></span>
          </div>
        </div>
        <!--  -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-bottom: 20px"
          v-print="trainPrintObj"
          icon="el-icon-printer"
          size="small"
          >打印</el-button
        >
        <el-button type="primary" @click="trainQrCodeVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择心理训练弹框-->
    <el-dialog
      title="选择心理训练方式"
      :visible.sync="practiceDialogVisible"
      width="50%"
      :append-to-body="true"
      @opened="getTrainList"
      @close="ResetType"
    >
      <!-- 选择心理训练方式 -->
      <div>
        <el-select
          v-model="trainListQuery.TrainType"
          placeholder="请选择心理训练类型"
          @change="GetTrainByType"
        >
          <el-option label="音乐治疗处方" :value="1"></el-option>
          <el-option label="视频干预处方" :value="2"></el-option>
          <el-option label="心理动漫处方" :value="3"></el-option>
        </el-select>
      </div>
      <!--  -->
      <el-table
        ref="multipleTable"
        :data="trainList"
        tooltip-effect="dark"
        style="width: 100%; font-size: 14px"
        height="400"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="编号" prop="ID"></el-table-column>
        <el-table-column label="名字" prop="Name"></el-table-column>
        <el-table-column label="描述" prop="Describe"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="practiceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="trainSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <!-- 解决告警 -->
    <el-dialog
      title="解决告警"
      :visible.sync="SolvedialogVisible"
      :append-to-body="true"
      width="700px"
      @close="ResetCondition"
    >
      <div style="margin-bottom: 20px; width: 400px">
        <el-select v-model="Solvedvalue" placeholder="请选择解决方式">
          <el-option label="心理测评" :value="1"></el-option>
          <el-option label="心理训练" :value="2"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SolvedialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="SelectMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!--  -->
    <!-- 详细报告 -->
    <el-dialog
      title="查看详细报告"
      :visible.sync="detaildialogVisible"
      v-if="detaildialogVisible"
      :before-close="handleClose"
      width="850px"
      :append-to-body="true"
    >
      <detailReport
        style="width: 100%"
        :doctorName="currentDoctor"
        @reportData="reportData"
        :admScaleID="detailadmScaleID"
        :isDetaled="true"
        id="print"
        @changereport="changereport"
      >
        <div class="dialog-slot">
          <el-button
            type="primary"
            v-print="printObject"
            :disabled="
              currentScaleInfo && currentScaleInfo.ExamineUserID == null
                ? true
                : false
            "
            >打 印</el-button
          >
          <el-button
            v-if="currentScaleInfo && currentScaleInfo.ExamineUserID == null"
            type="primary"
            @click="examine"
            >审 核</el-button
          >
          <el-button v-else type="primary" disabled>已 审 核</el-button>
        </div>
      </detailReport>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          v-print="printObject"
          :disabled="
            currentScaleInfo && currentScaleInfo.ExamineUserID == null
              ? true
              : false
          "
          >打 印</el-button
        >
        <el-button
          v-if="currentScaleInfo && currentScaleInfo.ExamineUserID == null"
          type="primary"
          @click="examine"
          >审 核</el-button
        >
        <el-button v-else type="primary" disabled>已 审 核</el-button>
      </span> -->
    </el-dialog>
    <!-- 答题情况 -->
    <el-dialog
      title="答题情况"
      :visible.sync="answerdialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
      width="50%"
      class="scaleList"
      ref="answerDialog"
    >
      <TestList
        v-if="answerdialogVisible"
        v-loading="lazyLoading"
        :jsonData="jsonData"
      ></TestList>
      <span slot="footer" class="dialog-footer">
        <el-button @click="answerdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="answerdialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog
      title="修改密码"
      :visible.sync="ChangePwdFlag"
      @close="resetField"
      :append-to-body="true"
    >
      <div style="text-align: center">
        <el-form
          :rules="Rules"
          ref="changepwd"
          label-width="120px"
          :model="password"
        >
          <el-form-item label="原密码" prop="OldPassword">
            <el-input
              v-model="password.OldPassword"
              placeholder="请输入原密码"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="NewPassword">
            <el-input
              v-model="password.NewPassword"
              placeholder="请输入新密码"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="重复新密码" prop="repeatpwd">
            <el-input
              v-model="password.repeatpwd"
              placeholder="请输入新密码"
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ChangePwdFlag = false">取 消</el-button>
        <el-button @click="SavePwd">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import langSelect from "../../../components/lang/langSelect";
import vue from "vuex";
import tabNav from "./tabNav";
import { Axios, AsyncAxios } from "@/common/request";
import detailReport from "@/views/hospital/detailReport";
import TestList from "@/components/TestList";
import QRCode from "qrcode";
import { dateFormat } from "@/utils/date";
export default {
  name: "Header",
  components: {
    tabNav,
    langSelect,
    detailReport,
    TestList,
  },
  data() {
    return {
      KeepStatus: 1, //保留选中类型的状态
      nowDate: "", //打印时间
      //打印心理训练二维码
      trainPrintObj: {
        id: "trainQrCode",
        popTitle: "",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      parintinfo: null, //心理训练返回来的个人基本信息
      checkedTrainNames: null,
      admNumber: "", //生成二维码的Number
      trainID: null, //心理训练编号
      trainQrCodeVisible: false, //心理训练二维码弹框
      multipleSelection: [], //选中心理训练
      practiceDialogVisible: false,
      trainList: null,
      trainListQuery: {
        ClassID: "",
        KeyWord: "",
        PageIndex: 1,
        PageSize: 100,
        status: true,
        TrainType: 1, //心理训练类型
      },
      currentAlarmMsg: null, //存储当前告警信息
      Solvedvalue: 1,
      SolvedialogVisible: false, //解决弹框
      ChangePwdFlag: false,
      isfullScreen: true,
      avatar: "./static/images/icon.jpg",
      role: "",
      user: "",
      roleid: 4,
      HospitalName: "",
      Rules: {
        OldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: "blur",
          },
        ],
        NewPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
        repeatpwd: [
          {
            required: true,
            message: "请重新输入新密码",
            trigger: "blur",
          },
        ],
      },
      password: {
        OldPassword: "",
        NewPassword: "",
        repeatpwd: "",
      },
      isShow: false,
      alarmObj: {},
      currentDoctor: "",
      isMessageShow: true,
      detaildialogVisible: false,
      answerdialogVisible: false,
      lazyLoading: false,
      detailadmScaleID: "",
      printObject: {
        id: "print",
        popTitle: "查看诊断报告",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      currentScaleInfo: {},
      jsonData: [],
    };
  },
  mounted() {
    const date = new Date().getTime();
    this.nowDate = dateFormat(date, "yyyy-MM-dd hh:mm:ss"); //获取打印时间
    this.roleid = this.$store.getters.info.RoleID;
    this.role = this.$store.getters.info.RoleName;
    this.user = this.$store.getters.info.UserName;
    // 医生角色轮询告警信息

    if (this.roleid == 4 || this.roleid == 3) {
      this.getTopAlarmPerson();
      // 图标闪烁
      setInterval(() => {
        this.isMessageShow = !this.isMessageShow;
      }, 500);
    }
  },
  methods: {
    //保存成功后关闭弹框
    changereport() {
      this.detaildialogVisible = false;
    },
    //   关闭心理二维码弹框事件
    closeQrCodeDialog() {
      this.trainQrCodeVisible = false;
      this.KeepStatus = 1; //重置选中类型
    },
    // 根据type获取训练列表
    GetTrainByType() {
      this.getTrainList();
      this.KeepStatus = this.trainListQuery.TrainType;
    },
    //清空训练方式类型
    ResetType() {
      this.trainListQuery.TrainType = 1;
    },
    //清空筛选条件
    ResetCondition() {
      this.Solvedvalue = 1;
    },
    //  生成心理训练二维码
    trainOpenQrDialog() {
      var canvas = document.getElementById("trainCanvas");
      console.log(canvas);
      console.log("这是训练方式二维码");
      if (this.admNumber) {
        QRCode.toCanvas(
          canvas,
          this.$store.getters.qrcodeUrl +
            "/startTran?number=" +
            this.admNumber +
            "&time=" +
            new Date().getTime(),
          function (error) {
            if (error) console.error(error);
            console.log("QRCode success!");
          }
        );
      } else {
        //音频课程
        if (this.KeepStatus == 1) {
          QRCode.toCanvas(
            canvas,
            this.$store.getters.qrcodeUrl +
              "/voiceList?number=" +
              this.trainID +
              "&time=" +
              new Date().getTime(),
            function (error) {
              if (error) console.error(error);
              console.log("QRCode success!");
            }
          );
        } else {
          //视频课程
          QRCode.toCanvas(
            canvas,
            this.$store.getters.qrcodeUrl +
              "/videoList?number=" +
              this.trainID +
              "&time=" +
              new Date().getTime(),
            function (error) {
              if (error) console.error(error);
              console.log("QRCode success!");
            }
          );
        }
      }
    },
    //提交训练方式
    trainSubmit() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "未选择训练方式",
          type: "warning",
        });
      } else {
        var IDs = [];
        this.checkedTrainNames = this.multipleSelection;
        this.multipleSelection.forEach((item) => {
          IDs.push(item.ID);
        });
        Axios(
          "Business/AddAdmTrain",
          "post",
          {
            PadmID: this.currentAlarmMsg.PaadmID,
            ScaleIDs: IDs,
            TrainType: this.trainListQuery.TrainType,
          },
          this
        ).then((res) => {
          if (res.Status == 1 && res.Data) {
            this.SolvedAlarmData();
            this.trainID = res.Data.data;
            this.practiceDialogVisible = false;
            this.trainQrCodeVisible = true;
            this.$refs.multipleTable.clearSelection();
            this.parintinfo = res.Data.parintinfo;
          } else {
            this.$message({
              message: res.Message,
              type: "error",
            });
          }
        });
      }
    },
    // 解决告警
    SolvedAlarmData() {
      Axios(
        "Alarm/SolvedAlarmData",
        "get",
        {
          AlarmID: this.currentAlarmMsg.AlarmID,
          Pa_AdmID: this.currentAlarmMsg.PaadmID,
        },
        this
      ).then((ret) => {
        if (ret.Status) {
          this.$message.success("解决告警成功！");
        } else {
          this.$message.warning("解决告警失败");
        }
      });
    },
    // 表格选中心理训练方式
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //   获取心理训练列表
    getTrainList() {
      Axios("BaseData/GetNewTrainList", "post", this.trainListQuery, this).then(
        (ret) => {
          if (ret.Status == 1 && ret.Data) {
            this.trainList = ret.Data;
            console.log(this.trainList);
          }
        }
      );
    },
    // 查看报告
    handleDetailReport(row) {
      // this.currentScaleInfo = row;
      this.detailadmScaleID = row.AdmscaleID;
      //  this.currentDoctor = row.DoctorName;
      this.detaildialogVisible = true;
      this.isShow = false;
    },
    // 查看答题情况
    handleAnswerRecord(row) {
      this.answerdialogVisible = true;
      this.isShow = false;
      this.lazyLoading = true;
      this.getAnswer(row);
    },
    // 获取答题情况
    getAnswer(row) {
      Axios(
        "Business/GetAnswer",
        "get",
        {
          admScaleID: row.AdmscaleID,
        },
        this
      ).then((ret) => {
        this.lazyLoading = false;
        this.jsonData = ret.Data.admQuestionList;
      });
    },
    // 获取实时告警信息
    getTopAlarmPerson() {
      Axios(
        "Alarm/GetTopAlarmPerson",
        "get",
        {
          TopNum: 5,
        },
        this
      ).then((res) => {
        if (res.Status) {
          this.alarmObj = res.Data;
          console.log(this.alarmObj);
          // 轮询
          setTimeout(() => {
            this.getTopAlarmPerson();
          }, 5000);
        } else {
        }
      });
    },
    // 选择解决告警的方式
    SelectMethod() {
      this.SolvedialogVisible = false;
      if (this.Solvedvalue == 1) {
        //选择心理测评的方式
        this.psychologyEvaluation();
      } else {
        this.practiceDialogVisible = true;
      }
    },
    // 解决告警
    solveAlarm(row) {
      //存储当前告警信息
      this.currentAlarmMsg = row;
      if (this.currentAlarmMsg.PhysicalPlanNumber) {
        this.admNumber = this.currentAlarmMsg.PhysicalPlanNumber;
      } else {
        this.admNumber = 0;
      }
      this.SolvedialogVisible = true;
      this.isShow = false;
    },
    // 心理测评
    psychologyEvaluation() {
      Axios(
        "Alarm/SolvedAlarmGetAdmNo",
        "get",
        {
          AlarmID: this.currentAlarmMsg.AlarmID,
        },
        this
      ).then((res) => {
        if (res.Status) {
          this.$router.push({
            name: `diagnosisManage`,
            params: {
              AdmNO: res.Data.AdmNo,
              AlarmID: this.currentAlarmMsg.AlarmID,
            },
          });
        } else {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        }
        this.isShow = false;
      });
    },
    // solveAlarm1(row, index) {
    //   Axios(
    //     "Alarm/SolvedAlarmGetAdmNo",
    //     "get",
    //     {
    //       AlarmID: row.AlarmID,
    //     },
    //     this
    //   ).then((res) => {
    //     if (res.Status) {
    //       this.$router.push({
    //         name: `diagnosisManage`,
    //         params: {
    //           AdmNO: res.Data.AdmNo,
    //           AlarmID: row.AlarmID,
    //         },
    //       });
    //     } else {
    //       this.$message({
    //         message: "操作失败",
    //         type: "error",
    //       });
    //     }
    //     this.isShow = false;
    //   });
    // },
    // 忽略告警
    ignoreAlarm(row) {
      this.$confirm("确认忽略该条告警信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          Axios(
            "Alarm/GnoreAlarmData",
            "get",
            {
              AlarmID: row.AlarmID,
            },
            this
          ).then((res) => {
            if (res.Status) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTopAlarmPerson();
            } else {
              this.$message({
                message: "操作失败",
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 审核
    examine() {
      this.$confirm("确认报告信息无误?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Axios("Business/SetExamineScale", "post", {
          AdmScaleID: this.currentScaleInfo.ID,
        }).then((res) => {
          if (res.Status == 1) {
            this.$message({
              message: "审核成功",
              type: "success",
            });

            Axios(
              "Business/GetAdmScaleReport",
              "get",
              {
                admScaleID: this.currentScaleInfo.ID,
              },
              this
            ).then((res) => {
              if (res.Status == 1) {
                this.currentScaleInfo = res.Data.patientInfo;
              }
            });
          }
        });
      });
    },
    // 获取报告数据
    reportData(data) {
      if (data) {
        this.currentScaleInfo = data.patientInfo;
      }
    },
    // 关闭弹框
    handleClose() {
      this.detaildialogVisible = false;
      this.answerdialogVisible = false;
    },
    // 跳转到告警页面
    toAlarmPage() {
      this.isShow = false;
      this.$router.push({
        path: "/alarm",
      });
    },
    resetField() {
      this.$refs["changepwd"].resetFields();
    },
    collapse() {
      this.$store.state.menuIsShow = !this.$store.state.menuIsShow;
    },
    fullScreen() {
      if (this.isfullScreen) {
        var docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
        this.isfullScreen = false;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isfullScreen = true;
      }
    },
    SavePwd() {
      var that = this;
      if (this.password.NewPassword != this.password.repeatpwd) {
        this.$message({
          type: "error",
          message: "重复输入入的新密码不同！",
        });
        return false;
      }
      this.$refs["changepwd"].validate((valid) => {
        if (valid) {
          Axios("sys/UpdatePwd", "post", this.password, this).then((ret) => {
            this.ChangePwdFlag = ret.Status != 1;
            if (ret.Status == 1) {
              this.$message({
                type: "success",
                message: ret.Message,
              });
              // 清空token 刷新页面
              Cookies.remove("token");
              window.sessionStorage.clear();
              // location.reload();
              this.$router.replace("/login");
            } else {
              this.$message({
                type: "error",
                message: ret.Message,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    handleCommand(command) {
      if (command === "logout") {
        Cookies.remove("token");
        window.sessionStorage.clear();
        // this.$router.push("/login");
        location.reload();
      } else if (command == "changePassword") {
        this.ChangePwdFlag = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);

%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}
.dialog-slot {
  display: flex;
  padding-left: 14px;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 20px 0;
}
// 心理训练二维码
.title_warp {
  display: none;

  .date {
    font-size: 16px;
  }

  .hospital {
    font-size: 26px;
    text-align: center;
    color: #000;
  }
}
.canvas-warp {
  width: 180px;
  height: 180px;
  margin: 0 auto;
}
.traincontent {
  .title {
    text-align: center;
    line-height: 40px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}
.traincontent .tab {
  width: 100%;
  margin: 0 auto;
  tr {
    td {
      border: 1px solid #ebeef5;
      line-height: 30px;
      font-size: 14px;
      color: #606266;
      padding: 5px;
    }
  }
}
.traincontent .subTitle {
  text-align: left;
  height: 40px;
  line-height: 40px;
  padding-left: 5px;
  color: #222;
}

//
.fa-bars {
  font-size: 22px;
}
.title {
  margin-left: 20px;
  font-size: 22px;
  font-weight: 400;
  font-family: "微软雅黑 Regular", "微软雅黑";
  color: white;
}

.el-dropdown {
  font-size: 16px;
}

html,
body,
#app,
.el-container,
#asideNav,
ul.el-menu {
  @extend %h100;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}

.headerS {
  position: relative;
  z-index: 2;
}

#header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("../../../assets/images/titBG.png");
  background-size: 100% 65px;
  box-shadow: 0px 0px 20px 10px rgba(27, 60, 206, 0.2) !important;
  -webkit-box-shadow: 0px 0px 20px 10px rgba(27, 60, 206, 0.4) !important;
  .hideAside {
    @extend %cursor;
    color: white;
  }

  .personal {
    display: flex;
    align-items: center;
    flex-direction: row;

    li {
      @include set-value(margin, 13px);
      font-size: 16px;
      color: white !important;
    }

    .fullScreen {
      @extend %cursor;
    }

    .el-dropdown-link {
      @extend %cursor;
    }
  }
}

.headerIcon {
  i {
    line-height: 60px;
  }
}
.item {
  /deep/ .el-badge__content.is-fixed {
    top: 20px !important;
    right: 10px !important;
    border: none;
    text-align: center;
    padding: 0;
    font-size: 10px;
    height: 15px;
    width: 15px;
    line-height: 15px;
  }
}

/* 告警列表样式 */

.el-popover {
  top: 40px !important;
  left: 846px !important;
}

.message_warp {
  position: relative;
  width: 30px;
  cursor: pointer;
}

.message_warp .message_number {
  position: absolute;
  left: 11px;
  top: 10px;
  padding: 0 6px;
  font-size: 10px;
  background: #c71616;
  border-radius: 10px;
}

.message_popover {
  padding: 0 10px 10px 10px;
}

.message_popover {
  padding: 0 10px 10px 10px;
}

.people {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-size: 14px;
  color: #687782;
}

.message_popover .head .more {
  cursor: pointer;
  font-size: 20px;
}

.message_popover .head .message_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.line {
  height: 1px;
  border-bottom: 1px solid #ddd;
  margin: 10px 0;
}

.total_line {
  padding: 0 20px;
  color: rgb(238, 238, 238);
  font-weight: 100;
  font-size: 24px;
}

.message_head_warp {
  display: flex;
  align-items: center;
}

.message_popover .head .title {
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  margin-left: 0;
  color: #01058a;
}

.total_text {
  font-family: "\5FAE\8F6F\96C5\9ED1 Bold", "\5FAE\8F6F\96C5\9ED1";
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #006dba;
  margin-right: 28px;
}

.all_warp {
  display: flex;
  align-items: center;
}

.total_all {
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #a29faa;
}

.message_popover .head .message_head {
  display: flex;
  align-items: center;
}

.message_popover .head .more {
  color: rgb(184, 186, 192) !important;
}

.alarm_tab tr th {
  font-family: "微软雅黑 Regular", "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #a29faa;
  line-height: 40px;
}

.alarm_tab tr td {
  line-height: 45px;
  border-bottom: 1px solid rgb(235, 235, 235);
  font-family: "微软雅黑 Bold", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  color: #2d3037;
}

.operation span {
  margin: 0 5px;
  cursor: pointer;
  color: #409eff;
  font-weight: 400;
}

.circular {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 5px;
  background: #d43c3c;
}
.circular_warp {
  display: flex;
  align-items: center;
}
.alarm_severity {
  color: #fff;
  padding: 2px 5px;
  border-radius: 5px;
}
</style>

<style>
@media print {
  #trainQrCode .train-bottom {
    border-bottom: 1px solid #000;
  }
  #qrCode .print-Warp,
  #trainQrCode .print-Warp {
    width: 100%;
    margin: 0 auto;
    border: 1px solid #000;
    /* border-left: 1px solid #000;
    border-bottom: 1px solid #000; */
  }
  #qrCode .title_warp,
  #trainQrCode .title_warp {
    display: block;
  }
  #qrCode .canvas-bar .box,
  #trainQrCode .canvas-bar .box {
    width: 100%;
    height: 324px;
    padding-top: 70px;
  }
  #qrCode .canvas-warp,
  #trainQrCode .canvas-warp {
    width: 180px;
    height: 180px;
    margin: 0 auto;
  }
  #qrCode .subTitle,
  #trainQrCode .subTitle {
    font-size: 22px !important;
    color: #000;
    font-weight: 500;
  }
  #qrCode .border-bottom,
  #trainQrCode .border-bottom {
    border-bottom: 1px solid #000;
  }
  #qrCode .title,
  #trainQrCode .title {
    font-size: 25px;
    color: #000;
    line-height: 40px;
  }
  #qrCode .tab,
  #trainQrCode .tab {
    font-size: 20px;
    border-right: none;
    border-left: none;
    color: #000;
  }
  #qrCode .tab thead td,
  #trainQrCode .tab thead td {
    font-size: 20px;
  }
  #qrCode .tab tbody td,
  #trainQrCode .tab tbody td {
    font-size: 18px !important;
  }
  #qrCode .text-right,
  #trainQrCode .text-right {
    font-size: 20px;
    display: block !important;
    line-height: 30px;
    text-align: right;
    margin-right: 20px;
    color: #000 !important;
    margin-top: 20px;
  }
  #qrCode .text-right span,
  #trainQrCode .text-right span {
    margin-right: 90px;
  }
  #qrCode .tab-warp,
  #trainQrCode .tab-warp {
    /* border: 1px solid #000; */
    border: none;
  }
  #qrCode .tab td,
  #trainQrCode .tab td {
    color: #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  #qrCode .tab .td_right,
  #trainQrCode .tab .td_right {
    border-right: none !important;
  }
  #qrCode .tab .td_top,
  #trainQrCode .tab .td_top {
    border-top: none !important;
  }
  #qrCode #tab,
  #trainQrCode #tab {
    border-right: none;
    /* border-bottom: 1px solid #000; */
    min-height: 100%;
    margin-bottom: 20px;
  }

  #qrCode .AdmNO,
  #trainQrCode .AdmNO {
    font-size: 20px;
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header/header.vue